import { render, staticRenderFns } from "./DeliveryStart.vue?vue&type=template&id=23bdef9d&"
import script from "./DeliveryStart.vue?vue&type=script&lang=js&"
export * from "./DeliveryStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports